import "./SimpleCardBox.css";

const SimpleCardBox = ({children, defaultPadding = false, defaultMargin = true, dontOvergrow = false, extraClass = "", animateHover = false, showOverflow = false, extraStyle = {}}) => (
    <div style={extraStyle} className={`simple-card-box ${defaultPadding ? "padded-card-box" : ""} ${defaultMargin ? "margin-card-box" : ""} ${extraClass} ${animateHover ? "simple-card-box-animate" : ""} ${dontOvergrow ? "stop-overgrow" : ""} ${showOverflow ? "show-overflow" : ""}`.trim()}>
        {children}
    </div>
);

export default SimpleCardBox;